( function ( $ ) {
  $( document ).on('click', '.event-tracking', function(){
    var event_value = 0;
    var event_label = "";
    if ($(this)[0].hasAttribute("data-event-category") && $(this)[0].hasAttribute("data-event-action")) {
      if ($(this).attr("data-event-label") != '') {
        event_label = $(this).attr("data-event-label");
      }
      if ($(this).attr("data-event-value") != '') {
        event_value = parseInt($(this).attr("data-event-value"));
      }

      ga('send', {
        hitType: 'event',
        eventCategory: $(this).attr("data-event-category"),
        eventAction: $(this).attr("data-event-action"),
        eventLabel: event_label,
        eventValue: event_value
      });
    }
  });
  
}) ( jQuery );